
define('text!modules/salesforce/drawer/templates/base.salesforce.drawer.template.html',[],function () { return '';});

